import axios from 'axios';

// Función para realizar la solicitud GET a la API
export const registrarLicencia = async (codigoLicencia) => {
    try {


        // console.log(process.env)
        // const idUsuario = 1
        // console.log(process.env.REACT_APP_SERVER_BACKEND)
        // console.log(`${process.env.REACT_APP_SERVER_BACKEND}/v1/formulario`)
        const response = await axios.get(`${process.env.REACT_APP_SERVER_BACKEND}/v1/registrar/${codigoLicencia}`);

        if (response.status === 200) {
            console.log("response.data", response)
            return response;
        } else {
            throw new Error(`Error en la solicitud. Código de estado: ${response.status}`);
        }


    } catch (error) {
        console.error('Error al obtener los datos:', error);
        throw new Error('Error al obtener los datos ' + error);
    }
};
